module.exports = __webpack_public_path__ + "img/FM_Certificate.f02abf3e.png";